import { createStyles } from "antd-style";

const useScheduleScreenStyles = createStyles(({ css, prefixCls, token }) => {
  return {
    screen: css`
      background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
      height: 100%;
      .emptySlots {
        border-radius: var(--Global-token-Radius-radiusXL, 24px);
        background: var(--Global-token-Bg-colorBgBase, #fff);
        padding: var(--Global-token-Padding-padding, 16px);
      }

      .noTime {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Headline/Semibold */
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 112%; /* 16.8px */
      }
      .closeBtn {
        width: 204px;
        padding: var(--General-Button-paddingBlockXS, 8px) var(--General-Button-paddingInlineSM, 12px);

        color: var(--Global-token-Primary-colorPrimaryText, #1677ff);
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Callout/Semibold */
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%; /* 15.6px */
      }
    `,

    calendar: css`
      .header {
        padding: var(--Global-token-Padding-padding, 16px);

        svg {
          cursor: pointer;
          color: var(--Global-token-Icon-colorIconActive, #1677ff);
        }

        .no-back {
          color: ${token["neutral-gray-6"]};
          cursor: not-allowed;
        }
      }

      .${prefixCls}-picker-cell:has(.foreign-cell) {
        visibility: hidden;
      }

      .foreign-cell {
        display: none !important;
      }
      .${prefixCls}-picker-content {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Callout/Regular */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 15.6px */
      }
      .${prefixCls}-picker-panel {
        border: none;
      }

      .${prefixCls}-picker-body {
        padding: var(--Global-token-Padding-padding, 16px);
      }

      .${prefixCls}-picker-cell-inner {
        &::before {
          display: none;
        }
      }

      .${prefixCls}-picker-cell {
        border-radius: var(--Global-token-Radius-radiusLG, 16px);

        & > * {
          transition: none;
        }

        &:active {
          background: var(--Global-token-Warning-colorWarning, #ffc53d);
        }
      }

      .${prefixCls}-picker-cell-inner {
        border-radius: var(--Global-token-Radius-radiusLG, 16px);

        width: 32px;
        height: 32px;

        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      .${prefixCls}-picker-calendar-date-value {
      }
      .${prefixCls}-picker-cell {
      }
      .${prefixCls}-picker-cell-disabled {
        &::before {
          display: none;
        }

        &.${prefixCls}-picker-cell {
          &:active {
            background: ${token.red3};
          }
        }

        .${prefixCls}-picker-cell-inner {
          background: var(--Data-Display-Table-colorTabBg, #f5f5f5);

          &:active {
            background: ${token.red3};
          }
          .${prefixCls}-picker-calendar-date-value {
            color: var(--Global-token-Text-colorTextDisabled, rgba(0, 0, 0, 0.25));
          }
        }
      }

      .${prefixCls}-picker-cell-selected {
        .${prefixCls}-picker-cell-inner {
          background: var(--Global-token-Warning-colorWarning, #ffc53d);
          padding: var(--Global-token-Padding-paddingS, 8px);

          .${prefixCls}-picker-calendar-date-value {
            color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
            font-feature-settings: "liga" off, "clig" off;

            /* MD/Callout/Regular */
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 100%;
          }
        }

        &.${prefixCls}-picker-cell-disabled {
          .${prefixCls}-picker-cell-inner {
            background: var(--Data-Display-Table-colorTabBg, #f5f5f5);
            .${prefixCls}-picker-calendar-date-value {
              color: var(--Global-token-Text-colorTextDisabled, rgba(0, 0, 0, 0.25));
            }
          }
        }
      }
    `,

    rangePicker: css`
      padding: var(--Global-token-Padding-padding, 16px);

      border-radius: var(--Global-token-Radius-radiusXL, 24px);
      background: var(--Global-token-Bg-colorBgBase, #fff);

      .rangeDivider {
        margin: 0;
        background: var(--Data-Display-Table-borderColor, #f0f0f0);
      }
      .pickerTitle {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Headline/Semibold */
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 112%; /* 16.8px */
      }
      .picker {
        flex-wrap: wrap;
      }
      .pickerItem {
        width: 108px;
        padding: var(--Global-token-Padding-paddingS, 8px) var(--Global-token-Padding-paddingSM, 12px);
        border-radius: var(--Global-token-Radius-radiusLG, 16px);
        background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
        transition: all 0.2s ease-in-out;
        cursor: pointer;

        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Callout/Regular */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 15.6px */

        &.picked {
          background: var(--Global-token-Warning-colorWarning, #ffc53d);
        }
      }
    `,
    timePicker: css`
      display: flex;
      flex-direction: column;
      padding: var(--Global-token-Padding-padding, 16px);
      border-radius: var(--Global-token-Radius-radiusXL, 24px);
      background: var(--Global-token-Bg-colorBgBase, #fff);
      border: none;
      .${prefixCls}-card-body {
        display: flex;
        flex-direction: column;
        gap: 16px;

        padding: 0;
      }
      .rangeDivider {
        margin: 0;
        background: var(--Data-Display-Table-borderColor, #f0f0f0);
      }
      .pickerTitle {
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;

        /* MD/Headline/Semibold */
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 112%; /* 16.8px */
      }
      .picker {
        flex-wrap: wrap;
      }
      .pickerItem {
        width: 108px;
        padding: var(--Global-token-Padding-paddingS, 8px) 0px;
        border-radius: var(--Global-token-Radius-radiusLG, 16px);
        background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
        transition: all 0.2s ease-in-out;
        color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
        font-feature-settings: "liga" off, "clig" off;
        cursor: pointer;

        /* MD/Callout/Regular */
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 15.6px */
        &.picked {
          background: var(--Global-token-Warning-colorWarning, #ffc53d);
        }
      }
    `,
    footer: css`
      border-radius: var(--Global-token-Radius-radiusXL, 24px) var(--Global-token-Radius-radiusXL, 24px) 0 0;
      background: var(--Global-token-Bg-colorBgBase, #fff);
      padding: 8px 16px;
    `,
  };
});
export default useScheduleScreenStyles;
